import { useNavigate } from "react-router-dom";
import PublicNav from "../components/PublicNav";

export default function TermsPage() {
  const navigate = useNavigate();

  const sections = [
    {
      title: "Acceptance",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          By creating an account and using Band OS, you agree to these terms.
          If you do not agree, please do not use the service.
        </p>
      ),
    },
    {
      title: "Your account",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          You are responsible for maintaining the security of your account
          credentials. You may not share your account with others or use Band OS
          for any unlawful purpose. You must be at least 13 years old to use
          the service.
        </p>
      ),
    },
    {
      title: "Your content",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          You retain ownership of any sheet music, setlists, and other content
          you upload to Band OS. By uploading content, you confirm that you have
          the right to store and use that content and that doing so does not
          infringe any third-party rights. Band OS does not claim ownership of
          your content.
        </p>
      ),
    },
    {
      title: "Subscription and billing",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Paid plans are billed monthly through Stripe. You may cancel your
          subscription at any time from the billing settings inside the app.
          Cancellation takes effect at the end of the current billing period —
          no refunds are issued for partial months. We reserve the right to
          change pricing with 30 days' notice.
        </p>
      ),
    },
    {
      title: "Service availability",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          We aim to keep Band OS available at all times but cannot guarantee
          uninterrupted access. We are not liable for any loss of data or
          revenue caused by downtime, bugs, or service interruptions.
        </p>
      ),
    },
    {
      title: "Termination",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          We reserve the right to suspend or terminate accounts that violate
          these terms. You may delete your account at any time by contacting us.
        </p>
      ),
    },
    {
      title: "Contact",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Questions about these terms? Email:{" "}
          <a
            href="mailto:legal@bandos.app"
            className="text-brand-gold hover:text-brand-gold/80 underline"
          >
            legal@bandos.app
          </a>
        </p>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-base font-sans">
      <PublicNav bandId={null} onHome={() => navigate("/")} />

      <div className="max-w-2xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate("/")}
          className="text-text-muted hover:text-text-primary text-sm bg-transparent border-0 p-0 mb-8 flex items-center gap-1.5 cursor-pointer transition-colors"
        >
          ← Back
        </button>

        <p className="text-brand-gold text-xs font-medium tracking-[0.2em] uppercase mb-3">
          Legal
        </p>
        <h1 className="font-display text-3xl text-text-primary mb-3">
          Terms of Service
        </h1>
        <p className="text-text-muted text-sm">Last updated: April 2025</p>

        {sections.map((section, i) => (
          <section
            key={section.title}
            className={
              i === 0
                ? "mt-10"
                : "border-t border-white/[0.06] mt-10 pt-10"
            }
          >
            <h2 className="text-text-primary text-lg font-medium mt-10 mb-3">
              {section.title}
            </h2>
            {section.body}
          </section>
        ))}
      </div>
    </div>
  );
}
